import { module } from 'modujs';
import modularLoad from 'modularload';
import { html } from '../utils/environment';

class superLoad extends modularLoad {
    refresh(href, transition) {
        this.reset()
        this.transition = transition
        this.isUrl = void 0

        this.setOptions((href || window.location.href), false)
    }
}

export default class extends module {
    init() {
        this.analyticsId = this.getData('analytics');

        this.load = new superLoad({
            enterDelay: 250,
            transitions: {
                'job-offer-list': {
                    enterDelay: 0,
                },
                'certificate-list': {
                    enterDelay: 0
                },
                'schedule': {
                    enterDelay: 0
                }
            }
        });

        this.load.on('loading', (transition, oldContainer) => {
            if (transition == 'job-offer-list') {
                this.call('scrollTo', { target: document.getElementById('job-offer-list'), offset: -150 }, 'Scroll')
            }

            if (transition == 'certificate-list') {
                this.call('scrollTo', { target: document.getElementById('certificate-list'), offset: 1 }, 'Scroll')
            }

            this.call('hide', null, 'Modal')

            html.classList.remove('has-header-nav-opened')
            html.classList.remove('has-menu-opened')
            html.classList.remove('has-account-menu-opened')

            this.call('destroyLoop', null, 'Scroll')
        })

        this.load.on('loaded', (transition, oldContainer, newContainer) => {
            this.call('destroy', oldContainer, 'app');
            this.call('update', newContainer, 'app');

            if (window.gtag && this.analyticsId != null) {
                gtag('config', this.analyticsId, {
                    'page_path':  location.pathname,
                    'page_title': document.title
                });
            }
        });

        this.load.on('ready', (transition) => {
            if(['job-offer-list', 'certificate-list'].includes(transition)) {
                this.call('update', null, 'Scroll')
            }

            if (transition == 'schedule') {
                this.call('scrollTo', { target: document.getElementById('schedule'), offset: -150 }, 'Scroll')
            }
        })
    }

    goTo(options) {
        let { url, transition } = options
        this.load.goTo(url, transition)
    }

    refresh(options) {
        let { url, transition } = options
        this.load.refresh(url, transition)
    }
}
